import React from 'react';
import { Box } from '@mui/material';
import UnifiedMessages from './UnifiedMessages';
import back from "../../../assets/back.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import CustomText, { textStyles } from "../../../components/CustomText";
import { useTranslation } from "react-i18next";
const MessagesLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const fromDashboard = location.state?.fromDashboard;
  return (
    <>
              {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1, mr:1
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('companyAdmin')} 
      </CustomText>
    </Box>
  </Box>
)}
    <Box sx={{ px: 1, mt: 1 }}>
      <UnifiedMessages />
    </Box>
    </>
  );
};

export default MessagesLayout;
